<template>
  <div class="channel-two-carousel">
    <div class="carousel-main">
      <!-- 左侧大图 -->
      <div
        class="carousel-image-wrap"
        v-if="items.length > 0"
        @click="goDetail(activeIndex)"
      >
        <img
          class="carousel-image"
          referrerpolicy="no-referrer"
          :src="items[activeIndex].img || DEFAULT_IMAGE"
          :alt="items[activeIndex].title"
          @load="onImgLoad(activeIndex)"
          @error="handleImageError($event, activeIndex)"
          :class="{ 'img-loading': !loadedMap[activeIndex] }"
        />
        <span
          v-if="!loadedMap[activeIndex]"
          class="img-placeholder"
        >加载中...</span>
      </div>

      <!-- 右侧文字列表 -->
      <div class="carousel-list">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="['carousel-item', { active: activeIndex === index }]"
          @mouseenter="setActive(index)"
        >
          <div class="carousel-title" @click="goDetail(index)">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChannelTwoCarousel',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      loadedMap: {}, // key: index, value: boolean
      DEFAULT_IMAGE: 'https://image.cbrand.com.cn/default/2026/10/AA38368160C540F19F19189B1D3A82AE.png'
    }
  },
  watch: {
    items(val) {
      if (val && val.length > 0) {
        this.activeIndex = 0
        this.loadedMap = {}
        this.$nextTick(() => {
          this.startAutoPlay()
          this.loadAllImages()
        })
      }
    }
  },
  mounted() {
    if (this.items.length > 0) {
      this.startAutoPlay()
      this.loadAllImages()
    }
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    // 实际渲染的 <img> 加载成功
    onImgLoad(index) {
      if (!this.loadedMap[index]) {
        this.$set(this.loadedMap, index, true)
        console.log(`图片 ${index + 1} 渲染加载成功`) // eslint-disable-line no-console
      }
    },

    // 图片加载失败：替换为默认图，并标记为已加载，避免一直显示“加载中”
    handleImageError(event, index) {
      const originalUrl = this.items[index] && this.items[index].img
      console.warn(`图片加载失败：${originalUrl}，切换为默认图片`) // eslint-disable-line no-console
      event.target.src = this.DEFAULT_IMAGE
      // 失败也标记为已加载
      if (!this.loadedMap[index]) {
        this.$set(this.loadedMap, index, true)
      }
    },

    // 预加载所有图片
    loadAllImages() {
      this.items.forEach((item, index) => {
        if (item.img) {
          const img = new Image()
          img.src = item.img
          img.onload = () => {
            if (!this.loadedMap[index]) {
              this.$set(this.loadedMap, index, true)
              console.log(`图片 ${index + 1} 预加载成功`) // eslint-disable-line no-console
            }
          }
          img.onerror = () => {
            console.warn(`图片 ${index + 1} 预加载失败`) // eslint-disable-line no-console
            // 失败也标记，避免一直显示“加载中”
            if (!this.loadedMap[index]) {
              this.$set(this.loadedMap, index, true)
            }
          }
        } else {
          // 没有 img，直接标记为已加载
          if (!this.loadedMap[index]) {
            this.$set(this.loadedMap, index, true)
          }
        }
      })
    },

    setActive(index) {
      this.activeIndex = index
      this.stopAutoPlay()
    },

    startAutoPlay() {
      this.stopAutoPlay()
      if (!this.items.length) return
      this.timer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.items.length
      }, 5000)
    },

    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    goDetail(index) {
      const item = this.items[index]
      if (item && item.newsCode) {
        window.open(`/zp/a/${item.newsCode}`, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.channel-two-carousel {
  width: 1400px;
  height: 485px;
  background-color: rgba(245, 245, 247, 1);
  overflow: hidden;
}

.carousel-main {
  display: flex;
  width: 100%;
  height: 100%;
}

/* 左侧大图 */
.carousel-image-wrap {
  width: 862px;
  height: 485px;
  flex-shrink: 0;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease, opacity 0.3s ease;
}

/* 加载中状态 - 半透明 */
.img-loading {
  opacity: 0.3 !important;
}

/* 图片占位符 - 居中显示 */
.img-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: rgba(102, 102, 102, 1);
  z-index: 1;
}

.carousel-image-wrap:hover .carousel-image {
  transform: scale(1.03);
}

/* 右侧文字列表 */
.carousel-list {
  flex: 1;
  padding: 0px 2px 0 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.carousel-item {
  width: 537px;
  min-height: 91px;
  padding: 15px 24px;
  box-sizing: border-box;
  background: transparent;
  transition: all 0.2s ease;
  position: relative;
}

.carousel-title {
  cursor: pointer;
}

.carousel-item:hover,
.carousel-item.active {
  background-color: rgba(255, 255, 255, 1);
}

.carousel-item.active::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-color: rgba(192, 5, 19, 1);
}

.carousel-title {
  font-size: 18px;
  color: rgba(102, 102, 102, 1);
  line-height: 32px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.2s;
}

.carousel-item:hover .carousel-title,
.carousel-item.active .carousel-title {
  color: rgba(0, 0, 0, 1);
}

.carousel-desc {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
  margin: 8px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>